<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group :label="$t('share.content.pinterest_form_notes')">
        <b-form-textarea v-model="form.note" rows=3 required>
        </b-form-textarea>
      </b-form-group> 
      <b-form-group :label="$t('share.content.pinterest_form_board')" v-if="!showBoardsTip">
        <b-form-select v-model="form.board" :options="boardsOptions" required></b-form-select>
      </b-form-group>
      <p v-if="showBoardsTip">
        No boards on you pinterest. You must create a boards first.
        Go to <a href="https://www.pinterest.com">pinterest</a>
      </p>
      <div class="icon-panel">
        <b-col class="text-right">
          <b-button type="submit" variant="primary">{{$t("share.content.pinterest_form_submit_btn")}}</b-button>
        </b-col>
      </div>
    </b-form>
  </div>
</template>


<script>
import {getPinterestData} from '../../services/api.js'
export default {
  name: 'Pinterest',
  data() {
    return {
      showBoardsTip: false,
      user_token: '',
      boardsOptions: {},
      form: {
        note: '',
        board: '',
        user_name: '',
      }
    }
  },
  methods: {
    onSubmit() {
      event.preventDefault()
      this.$emit('submit', this.form)
    }
  },
  created() {
    this.form.user_name = this.$cookie.get('p-user-name')
    if(!this.form.user_name) {
      let apiToken = this.$route.query.token
      let userToken = this.$cookie.get('s-token-pinterest')
      //get user token
      getPinterestData(apiToken, userToken)
        .then(data => {
          this.form.user_name = data.user_name
          if(data.boards.length > 0) {
            this.showBoardsTip = false
            let options = {}
            data.boards.forEach(value => {
              options[value.name] = value.name
            })
            this.boardsOptions = options
          } else {
            this.showBoardsTip = true
          }
          this.$cookie.set('p-user-name', this.form.user_name, {expires: '30m'})
          this.$cookie.set('p-user-boards', JSON.stringify(this.boardsOptions), {expires: '30m'})
          this.$emit('loaded')
        })
        .catch(error => {
          alert(error)
        })
    } else {
      let cookieBoardsOptions = JSON.parse(this.$cookie.get('p-user-boards'))
      if(cookieBoardsOptions && cookieBoardsOptions instanceof Object) {
        this.boardsOptions = cookieBoardsOptions
      }
      if(Object.keys(this.boardsOptions).length === 0) {
        this.showBoardsTip = true
      }
      this.$emit('loaded')
    }
  }
}
</script>
